// Auto-generated from gen_ce_info_and_maps.ts
// DO NOT EDIT THIS FILE DIRECTLY

import { CEMap } from '../types/ce';

import ZadnorCEs from './zadnor_encounters';

const data: CEMap<typeof ZadnorCEs> = {
  '207': 'LooksToDieFor',
  '210': 'ThereWouldBeBlood',
  '211': 'OnSerpentsWings',
  '212': 'AFamiliarFace',
  '213': 'TheDalriada',
  '218': 'LeanMeanMagitekMachines',
  '220': 'TakingTheLyonsShare',
  '221': 'WithDiremiteAndMain',
  '222': 'WornToAShadow',
  '20E': 'FeelingTheBurn',
  '20F': 'NeverCryWolf',
  '21B': 'FromBeyondTheGrave',
  '21C': 'HereComesTheCavalry',
  '21D': 'TimeToBurn',
  '21E': 'HeadOfTheSnake',
  '21F': 'TheBrokenBlade',
} as const;

export default data;
